import { render, staticRenderFns } from "./performance.vue?vue&type=template&id=17d79a8c&scoped=true"
import script from "./performance.js?vue&type=script&lang=js&external"
export * from "./performance.js?vue&type=script&lang=js&external"
import style0 from "./performance.less?vue&type=style&index=0&id=17d79a8c&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d79a8c",
  null
  
)

export default component.exports